<template>
  <form-modal
              :open="refreshPasswordOpened"
              :title="'Verify Identity'"
              :modal-name="modalName"
              @closed="closeModal()"
              :save="save"
              @valid="setFormValid(true)"
              @invalid="setFormValid(false)"
              :backdrop="false">
    <div class="form-group">
      <xm-input type="password" label="Password" v-model="password" required></xm-input>
    </div>
  </form-modal>
</template>

<script>
  import FormModal from './FormModal'
  import * as types from '../../store/mutation-types'
  import authRequest from '../../lib/authRequest'
  import { mapState } from 'vuex'
  import XmInput from '../XmInput.vue'

  export default {
    data () {
      return {
        modalName: 'refresh-password',
        formValid: false,
        password: '',
      }
    },

    computed: {
      ...mapState({
        username: state => state.user.username,
        refreshPasswordOpened: state => state.modals.refresh_password_modal_opened
      }),
    },

    methods: {
      closeModal () {
        this.resetForm()
        this.$store.commit(types.CLOSE_REFRESH_PASSWORD)
      },
      resetForm () {
        this.password = ''
      },
      save () {
        return authRequest.refreshAccessToken({
          username: this.username,
          password: this.password
        }).then(() => {
          this.closeModal()
        })
      },
      setFormValid (valid) {
        this.formValid = valid
      }
    },
    components: {
      XmInput,
      FormModal
    },
  }
</script>



// WEBPACK FOOTER //
// RefreshPasswordModal.vue?38adb0c3